export default __webpack_public_path__ + "static/media/aaps.9b3e27bd.svg";